import { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  patientRecommendations,
  getRecomFeedbackByUser,
} from "../../../services/apiCalls.js";
import RecommendationsTable from "./RecommendationsTable.jsx";

export default function RecommendationsComponent({ selectedUser }) {
  const [suggestedData, setSuggestedData] = useState([]);
  const [feedbackByRecommendationId, setFeedbackByRecommendationId] = useState({});
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation("recommendations");

  const refreshRecommendations = async () => {
    try {
      setLoading(true);
      // Fire both in parallel — the feedback endpoint degrades to [] on failure,
      // so the table still renders even if feedback isn't available yet.
      const [updatedRecommendations, feedbackRows] = await Promise.all([
        patientRecommendations(selectedUser),
        getRecomFeedbackByUser(selectedUser),
      ]);
      setSuggestedData(updatedRecommendations);
      const map = {};
      (feedbackRows || []).forEach((row) => {
        if (row?.recommendation_id) map[row.recommendation_id] = row;
      });
      setFeedbackByRecommendationId(map);
    } catch (error) {
      console.error(
        "Error when refreshing recommendations in Recommendations Component:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshRecommendations();
  }, []);

  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: "center", marginTop: "20px" }}>
        {t("title.page")}
      </Typography>
      <RecommendationsTable
        selectedUser={selectedUser}
        suggestedData={suggestedData}
        feedbackByRecommendationId={feedbackByRecommendationId}
        refreshRecommendations={refreshRecommendations}
        loading={loading}
      />
    </Box>
  );
}
